import React from 'react';
import { InformationIcon } from 'icons';
import { TooltipWrapper } from './FilterOption.styles';
import { SwitchTooltip } from './Tooltips';
import { Typography } from '../../Typography';

export const SwitchInfoTooltip: React.FC<{ switchTooltipContent: string }> = ({
  switchTooltipContent,
}) => {
  return (
    <SwitchTooltip
      title={
        <React.Fragment>
          <TooltipWrapper>
            <Typography fontSize="16px" lineHeight="1.5">
              {switchTooltipContent}
            </Typography>
          </TooltipWrapper>
        </React.Fragment>
      }
      placement="bottom"
    >
      <span>
        <InformationIcon />
      </span>
    </SwitchTooltip>
  );
};
